import PropTypes from 'prop-types';
import React from 'react';

import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import FirstPage from '@material-ui/icons/FirstPage';
import ArrowBack from '@material-ui/icons/ArrowBack';
import ArrowForward from '@material-ui/icons/ArrowForward';
import LastPage from '@material-ui/icons/LastPage';
import TextField from '@material-ui/core/TextField';

import globalStyles from './../../styles';

class Pagination extends React.Component {

  static propTypes = {
    onPaginate: PropTypes.func,
    data: PropTypes.any,
  };

  constructor(props) {

    super(props);
    this.state = {
      styleWidth: { width: 30 },
      totalPage: 0,
      page: 0,
      pageSize: 10,
    };

    this.firstPage = this.firstPage.bind(this);
    this.lastPage = this.lastPage.bind(this);
    this.nextPage = this.nextPage.bind(this);
    this.previousPage = this.previousPage.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
    this.calculatePage = this.calculatePage.bind(this);

  }

  firstPage() {

    const { onPaginate } = this.props;
    const { page } = this.state;

    if (page !== 0) {

      this.setState({ page: 1 });
      onPaginate(0);

    }

  }

  lastPage() {

    const { onPaginate } = this.props;
    const { page, totalPage } = this.state;

    if (page !== totalPage) {

      this.setState({ page: totalPage });
      onPaginate(totalPage - 1);

    }

  }

  nextPage() {

    const { onPaginate } = this.props;
    const { page } = this.state;
    const newPage = page + 1;
    this.setState({ page: newPage });
    onPaginate(newPage - 1);

  }

  previousPage() {

    const { onPaginate } = this.props;
    const { page } = this.state;
    const newPage = page - 1;
    this.setState({ page: newPage });
    onPaginate(newPage - 1);

  }

  changePage = (evt) => {

    const value = evt.target.value ? parseInt(evt.target.value, 10) : evt.target.value;
    const pageTotal = parseInt(this.state.totalPage, 10);

    if (value >= 0 && value <= pageTotal)
      this.setState({ page: value });

  }

  handleKeyPress = (e) => {

    const { onPaginate } = this.props;
    const { page } = this.state;

    if (e.key === 'Enter')
      onPaginate(page - 1);

  }

  handleFocus = () => this.setState({ page: '' });

  calculatePage = (props) => {

    const { data } = props;
    const actualPage = data.page ? data.page + 1 : 1;
    const totalPage = (data && data.totalItems) ?
      parseInt(Math.ceil(data.totalItems / data.pageSize), 10) :
      1;

    this.setState({ totalPage, page: actualPage });

  }

  componentWillMount = () => this.calculatePage(this.props);

  componentWillReceiveProps = nextProps => this.calculatePage(nextProps);

  render() {

    const { page, totalPage, styleWidth } = this.state;

    return (
      <div className="no-wrap" style={{ textAlign: 'right' }}>
        <span style={{ margin: '0 5px 0 5px', fontSize: 12 }}>
          <span>P&aacute;gina&nbsp;</span>
          {/* <TextField
            id="txtPaginate"
            onChange={this.changePage}
            value={page || ''}
            style={styleWidth}
            onKeyPress={this.handleKeyPress}
            onFocus={this.handleFocus}
          /> */}
          {page}
          <span>&nbsp;de&nbsp;</span>
          {this.state.totalPage}
        </span>
        <IconButton style={globalStyles.pagination} variant="fab" mini color="priamry" aria-label="first" onClick={this.firstPage} disabled={!page || page === 1} >
          <FirstPage />
        </IconButton>
        <IconButton style={globalStyles.pagination} variant="fab" mini color="priamry" aria-label="previous" onClick={this.previousPage} disabled={!page || page === 1} >
          <ArrowBack />
        </IconButton>
        <IconButton style={globalStyles.pagination} variant="fab" mini color="primary" aria-label="next" onClick={this.nextPage} disabled={!page || page === totalPage} >
          <ArrowForward />
        </IconButton>
        <IconButton style={globalStyles.pagination} variant="fab" mini color="primary" onClick={this.lastPage} disabled={!page || page === totalPage} >
          <LastPage />
        </IconButton>
      </div>
    );

  }

}

export default Pagination;



// WEBPACK FOOTER //
// ./src/components/table/Pagination.js